import { render } from "./all-file-manager.vue?vue&type=template&id=547d6c55&scoped=true"
import script from "./all-file-manager.vue?vue&type=script&lang=js"
export * from "./all-file-manager.vue?vue&type=script&lang=js"

import "./all-file-manager.vue?vue&type=style&index=0&id=547d6c55&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547d6c55"]])

export default __exports__